import { select } from '@clack/prompts'
import as from 'ansis'
import { Command } from 'commander'

import { getUserTeams } from '@/domains/team/helpers'
import { getAuthData, getDatabaseClient, refreshToken } from '@/helpers'
import { output } from '@/helpers/std-out'

export const SetCommand = () => {
  const cmd = new Command('set')

  cmd.description('Set current active team for the user')
  cmd.option('--team <team>', 'Team uid')
  cmd.action(async ({ team }) => {
    const auth = await getAuthData()
    auth.addEventListener((state) => Object.assign(auth, state))

    if (!('refreshToken' in auth)) {
      return output
        .error()
        .title('Unsupported operation')
        .message(
          'You can not change the selected team because you are using a personal token, which is related to a specific team. \nTo be able to perform actions on other teams you need to generate a new personal token and login with the new token.',
        )
        .exit('error')
    }

    const client = await getDatabaseClient()
    const userTeams = await getUserTeams(client, auth.email ?? '')

    if (userTeams.error) {
      return output
        .error()
        .title('An error occurred while getting list of teams.')
        .exit('error')
    }

    let teamValue = team

    // When the team is not provided as an argument
    if (!teamValue) {
      teamValue = await select({
        message: 'Please select one of the teams',
        options: userTeams.data.map((it) => ({
          value: it.teamUid,
          label: it.teamName,
        })),
      })
    }

    const selectedTeam = userTeams.data.find((it) => it.teamUid === teamValue)

    if (!selectedTeam) {
      return output
        .error()
        .title('Invalid team')
        .message('Please choose a valid team id')
        .exit('error')
    }

    // Setting new team
    await refreshToken(auth.refreshToken, teamValue)
    output
      .info()
      .message(
        `Operation ${as.green('successful')}. Selected team: ${as.cyan(selectedTeam.teamName)}`,
      )
      .print()
  })

  return cmd
}
